import { getCookie } from '../../common/utils/cookies';

/**
 * hanlde api error messages
 */
export const getLocalizedKeyByErrorMessage = (errorKey: string, isMfsPage?: true): string => {
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';
  let errorLocalizationKey = '';

  if (errorKey === 'NO_CANDIDATE_FOUND' || errorKey === 'USER_NOT_REGISTERED') {
    errorLocalizationKey = 'noCandidateFound';
  } else if (
    errorKey === 'signpage.invalid.emailpassword' ||
    errorKey === 'USER_CREDENTIALS_NOT_VALID' ||
    errorKey === 'EMAIL_USERNAME_NOT_FOUND'
  ) {
    errorLocalizationKey = isMfsPage ? 'usernamePasswordInvalid' : 'emailPasswordInvalid';
  } else if (errorKey === 'CANDIDATE_ALREADY_EXISTS' || errorKey === 'USER_ALREADY_REGISTERED') {
    errorLocalizationKey = 'candidateAlreadyExists';
  } else if (errorKey === 'signpage.deadline.passed') {
    errorLocalizationKey = 'deadLineDatePassed';
  } else if (errorKey === 'GENERIC_ERROR') {
    errorLocalizationKey = 'genericError';
  } else if (errorKey === 'PASS_SAME_PRE' || errorKey === 'PASSWORD_CANNOT_MATCH_LAST_3_PASSWORDS') {
    errorLocalizationKey = 'newPasswordCannotMatchOld';
  } else if (errorKey === 'PASS_IS_NOT_EMAIL') {
    errorLocalizationKey = 'newPasswordCannotContainEmail';
  } else if (errorKey === 'PASS_NOT_MIN_REQ') {
    errorLocalizationKey = 'newPasswordMinRequirement';
  } else {
    // pass the error message as it is
    errorLocalizationKey = errorKey;
    if (tcPlusFlow) errorLocalizationKey = 'genericError';
  }

  return errorLocalizationKey;
};
